import {catchError, map} from 'rxjs/operators';
import {Observable, of, OperatorFunction, throwError} from 'rxjs';
import {HttpErrorResponse} from '@angular/common/http';
import {none, Option, some} from 'fp-ts/lib/Option';

export function notFoundAsNull<T>(): OperatorFunction<T, T | null> {
  return catchError((e: any) => {
    if (e instanceof HttpErrorResponse && e.status === 404) {
      return of(null);
    } else {
      return throwError(e);
    }
  });
}

/* transforms a result x into some(x). In case of an HttpErrorResponse with status 404, returns none(). */
export function optional<T>(): OperatorFunction<T, Option<T>> {
  return (inputPipe: Observable<T>) => {
    return inputPipe.pipe(
      map((a) => some(a)),
      catchError((e: any) => {
        if (e instanceof HttpErrorResponse && e.status === 404) {
          return of(none);
        } else {
          return throwError(e);
        }
      }),
    );
  };
}
